import { GridApi, GridOptions, createGrid } from 'ag-grid-community';
import { Record } from '../RolePanelTypes';

export class RecordsGrid {
    api: GridApi<Record>;
    gridContainer: HTMLElement;

    async init(): Promise<void> {
        const response = await fetch('/rolePanel/records');
        const data: Record[] = await response.json();

        const gridOptions: GridOptions = {
            rowData: data,
            columnDefs: [
                {
                    field: 'Name',
                    headerName: 'Records',
                    flex: 1,
                    resizable: false
                }
            ],
            rowSelection: 'single',
            suppressCellFocus: true,
            onFirstDataRendered: (params) => params.api.getDisplayedRowAtIndex(0).setSelected(true),
        };

        this.gridContainer = document.createElement('div');
        this.gridContainer.classList.add('recordsGrid', 'ag-theme-quartz');
        this.api = createGrid(this.gridContainer, gridOptions);

        const firstDataRender = new Promise<void>((resolve) => {
            this.api.addEventListener('firstDataRendered', () => {
                resolve();
            });
        });

        await firstDataRender;
    }
}
